import React from 'react';
import PropTypes from 'prop-types';
import { Container, Typography } from '@material-ui/core';
import ErrorBear from '../../../assets/bearError.svg';
import { INFO_STORE_FORM } from '../../../constants/texts';
import { useStoreStyles } from './styles';

const StoreForm = (...props) => {
  const { mobile } = props;

  const classes = useStoreStyles({ mobile });

  return (
    <Container className={classes.container}>
      <img
        data-cy="errorImage"
        className={classes.image}
        src={ErrorBear}
        alt="error-bear"
      ></img>
      <Typography className={classes.title}>{INFO_STORE_FORM}</Typography>
    </Container>
  );
};

StoreForm.propTypes = {
  mobile: PropTypes.bool,
};

export default StoreForm;
